module.exports = __webpack_public_path__ + "img/default_team.26629154.png";